/*
Model auto-generated by: https://github.com/pmndrs/gltfjsx
Author: thesidekick (https://sketchfab.com/thesidekick)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/banana-dda3a1f707a94c52bed79578e120937c
Title: Banana
*/

import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import { Analytics } from '@vercel/analytics/react'
import './styles.css'
import Overlay from './layout/Overlay'
import { FadeIn } from './layout/styles'

import Bananas from './Bananas'
// Comment the above and uncomment the following to import the WebGL BG lazily for faster loading times
// const Bananas = lazy(() => import('./Bananas'))

function App() {
  return (
    <>
      <Suspense fallback={null}>
        <Bananas speed={3} />
        <FadeIn />
      </Suspense>
      <Overlay />
      <Analytics />
    </>
  )
}

createRoot(document.getElementById('root')).render(<App />)
